export default __webpack_public_path__ + "static/media/InventoryImg.dcdc6e60.svg";